//#region theme/frontend/islands/crt-effect.js
var BARREL_STRENGTH = .9;
var VIGNETTE_SIZE = 60;
var SCANLINE_OPACITY = .8;
var MAP_SIZE = 512;
var CrtEffect = class extends HTMLElement {
	connectedCallback() {
		this._active = false;
		const dataUrl = this._generateBarrelMap(MAP_SIZE, BARREL_STRENGTH);
		this._createFilter(dataUrl);
		this._createOverlay();
		this._onKey = (e) => {
			if (e.key === "o" && !e.metaKey && !e.ctrlKey && !e.altKey) this._active ? this.deactivate() : this.activate();
		};
		document.addEventListener("keydown", this._onKey);
	}
	_generateBarrelMap(size, strength) {
		const canvas = document.createElement("canvas");
		canvas.width = size;
		canvas.height = size;
		const ctx = canvas.getContext("2d");
		const img = ctx.createImageData(size, size);
		const data = img.data;
		const half = size / 2;
		for (let y = 0; y < size; y++) for (let x = 0; x < size; x++) {
			const nx = (x - half) / half;
			const ny = (y - half) / half;
			const r2 = nx * nx + ny * ny;
			const dx = strength * r2 * nx;
			const dy = strength * r2 * ny;
			const i = (y * size + x) * 4;
			data[i] = Math.round(128 + dx * 128);
			data[i + 1] = Math.round(128 + dy * 128);
			data[i + 2] = 128;
			data[i + 3] = 255;
		}
		ctx.putImageData(img, 0, 0);
		return canvas.toDataURL();
	}
	_createFilter(dataUrl) {
		const ns = "http://www.w3.org/2000/svg";
		this._svg = document.createElementNS(ns, "svg");
		this._svg.setAttribute("style", "position:absolute;width:0;height:0;pointer-events:none");
		const filter = document.createElementNS(ns, "filter");
		filter.id = "crt-barrel";
		filter.setAttribute("x", "0%");
		filter.setAttribute("y", "0%");
		filter.setAttribute("width", "100%");
		filter.setAttribute("height", "100%");
		filter.setAttribute("color-interpolation-filters", "sRGB");
		const feImage = document.createElementNS(ns, "feImage");
		feImage.setAttribute("href", dataUrl);
		feImage.setAttribute("result", "map");
		feImage.setAttribute("preserveAspectRatio", "none");
		const feDisplace = document.createElementNS(ns, "feDisplacementMap");
		feDisplace.setAttribute("in", "SourceGraphic");
		feDisplace.setAttribute("in2", "map");
		feDisplace.setAttribute("scale", "60");
		feDisplace.setAttribute("xChannelSelector", "R");
		feDisplace.setAttribute("yChannelSelector", "G");
		filter.append(feImage, feDisplace);
		this._svg.appendChild(filter);
		document.body.appendChild(this._svg);
	}
	_createOverlay() {
		this._overlay = document.createElement("div");
		this._overlay.style.cssText = "position:fixed;inset:0;pointer-events:none;z-index:9998;display:none";
		const vignette = document.createElement("div");
		vignette.style.cssText = `position:absolute;inset:0;background:radial-gradient(ellipse at center,transparent ${VIGNETTE_SIZE}%,rgba(0,0,0,0.8) 100%)`;
		const scanlines = document.createElement("div");
		scanlines.style.cssText = `position:absolute;inset:0;background:repeating-linear-gradient(to bottom,transparent 0px,transparent 2px,rgba(0,0,0,${SCANLINE_OPACITY}) 2px,rgba(0,0,0,${SCANLINE_OPACITY}) 4px)`;
		this._overlay.append(vignette, scanlines);
		document.body.appendChild(this._overlay);
	}
	activate() {
		this._active = true;
		document.documentElement.classList.add("crt-active");
		document.body.style.filter = "url(#crt-barrel)";
		this._overlay.style.display = "";
		const mask = document.getElementById("CrtEdgeMask");
		if (mask) mask.style.display = "";
	}
	deactivate() {
		this._active = false;
		document.documentElement.classList.remove("crt-active");
		document.body.style.filter = "";
		this._overlay.style.display = "none";
		const mask = document.getElementById("CrtEdgeMask");
		if (mask) mask.style.display = "none";
	}
	disconnectedCallback() {
		document.removeEventListener("keydown", this._onKey);
		this._svg?.remove();
		this._overlay?.remove();
		document.documentElement.classList.remove("crt-active");
		document.body.style.filter = "";
	}
};
customElements.define("crt-effect", CrtEffect);
//#endregion
